import * as types from 'store/modules/hres78u/mutation-types'
import hres78u from 'api/hres78u'
import swal from 'sweetalert'
import hres78uLabels from 'assets/labels/hres78u'
import { hres78uColumns } from 'assets/columns/hres78u'
import configLabel from 'src/../config/label'
import { constLabels } from 'assets/js/constLabels.js'
import * as dashTypes from 'store/modules/dash/mutation-types'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hres78uLabels,
    columns: hres78uColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail: {
      tab1: {},
      tab2: {},
      tab3: {
        table: {
          total: 0,
          rows: []
        }
      }
    },
    detailSubmit: {
      tab1: {}
    },
    dropdowns: {
      typintr: {
        en: {},
        th: {}
      }
    },
    trailRepayment: {},
    tableProcess: {
      total: 0,
      rows: []
    },
    datapersonal: {},
    approve: {},
    indexSelected: [],
    showTrailRepayment: false,
    showProcessTable: false,
    showPersonaldata: false
  },
  getters: {
    [types.GET_HRES78U_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES78U_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES78U_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES78U_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES78U_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES78U_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES78U_DETAIL] (state) {
      return state.detail
    },
    [types.GET_HRES78U_DETAIL_SUBMIT] (state) {
      return state.detailSubmit
    },
    [types.GET_HRES78U_DROPDOWNS] (state) {
      return state.dropdowns
    },
    [types.GET_HRES78U_POPUP_TRAILREPAYMENT] (state) {
      return state.trailRepayment
    },
    [types.GET_HRES78U_POPUP_PROCESSTABLE] (state) {
      return state.tableProcess
    },
    [types.GET_HRES78U_POPUP_PERSONALDATA] (state) {
      return state.datapersonal
    },
    [types.GET_HRES78U_SHOW_TRAILREPAYMENT] (state) {
      return state.showTrailRepayment
    },
    [types.GET_HRES78U_SHOW_PROCESSTABLE] (state) {
      return state.showProcessTable
    },
    [types.GET_HRES78U_SHOW_PERSONALDATA] (state) {
      return state.showPersonaldata
    }
  },
  mutations: {
    [types.SET_HRES78U_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES78U_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES78U_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].detailTab3Table = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab3Table, labels[keyLang])
        state.columns[keyLang].columnsProcessTable = configLabel.replaceLabelToColumns(state.columns[keyLang].columnsProcessTable, labels[keyLang])
      }
    },
    [types.SET_HRES78U_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRES78U_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRES78U_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES78U_DETAIL] (state, data) {
      state.detail = data
    },
    [types.SET_HRES78U_DETAIL_SUBMIT] (state, data) {
      state.detailSubmit = data
    },
    [types.SET_HRES78U_DROPDOWNS] (state, dropdowns) {
      state.dropdowns = dropdowns
    },
    [types.SET_HRES78U_POPUP_TRAILREPAYMENT] (state, trailRepayment) {
      state.trailRepayment = trailRepayment
      state.trailRepayment.rateilon = trailRepayment.rateilon1
    },
    [types.SET_HRES78U_POPUP_PROCESSTABLE] (state, tableProcess) {
      state.tableProcess = tableProcess
    },
    [types.SET_HRES78U_POPUP_PERSONALDATA] (state, datapersonal) {
      state.datapersonal = datapersonal
    },
    [types.SET_HRES78U_SHOW_TRAILREPAYMENT] (state, showTrailRepayment) {
      state.showTrailRepayment = showTrailRepayment
    },
    [types.SET_HRES78U_SHOW_PROCESSTABLE] (state, showProcessTable) {
      state.showProcessTable = showProcessTable
    },
    [types.SET_HRES78U_SHOW_PERSONALDATA] (state, showPersonaldata) {
      state.showPersonaldata = showPersonaldata
    }
  },
  actions: {
    [types.TOGGLE_HRES78U_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRES78U_INDEX_DISP, indexDisp)
      commit(types.SET_HRES78U_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRES78U_COLUMNS_LABELS] ({ commit }) {
      hres78u.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES78U_COLUMNS, data.labels)
          commit(types.SET_HRES78U_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES78U_INDEX] ({ commit }, searchParams) {
      hres78u.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES78U_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES78U_DETAIL] ({ commit }, detailParams) {
      hres78u.getDetail(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES78U_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES78U_DETAIL_SUBMIT] ({ commit }, detailParams) {
      hres78u.getDetailSubmit(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES78U_DETAIL_SUBMIT, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES78U_DROPDOWNS] ({ commit }) {
      hres78u.getDropdowns()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES78U_DROPDOWNS, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES78U_POPUP_TRAILREPAYMENT] ({ commit }, popupParams) {
      hres78u.getTrailRepayment(popupParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES78U_POPUP_TRAILREPAYMENT, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES78U_POPUP_PROCESSTABLE] ({ commit }, processParams) {
      commit(types.SET_HRES78U_SHOW_PROCESSTABLE, false)
      hres78u.postTableProcess(processParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES78U_POPUP_PROCESSTABLE, data)
          commit(types.SET_HRES78U_SHOW_PROCESSTABLE, true)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          commit(types.SET_HRES78U_SHOW_PROCESSTABLE, false)
        })
    },
    [types.RECEIVED_HRES78U_POPUP_PERSONALDATA] ({ commit }, personaldataParams) {
      hres78u.getPersonaldata(personaldataParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES78U_POPUP_PERSONALDATA, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRES78U_SEND_APPROVE] ({ commit, dispatch }, params) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          let referenceButton = params.referenceButton
          params.approveParams.flgwarning = 'N'
          hres78u.postSendApprove(params.approveParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              if (data.flg === 'warning') {
                swal({
                  title: constLabels('confirmTitle'),
                  text: data.response,
                  html: true,
                  showCancelButton: true,
                  closeOnConfirm: false,
                  confirmButtonText: constLabels('ok'),
                  cancelButtonText: constLabels('cancel')
                },
                function (isConfirm) {
                  if (isConfirm) {
                    swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
                    params.approveParams.flgwarning = 'Y'
                    hres78u.postSendApprove(params.approveParams)
                    .then((response) => {
                      const data = JSON.parse(response.request.response)
                      dispatch(types.RECEIVED_HRES78U_INDEX, params.searchParams)
                      dispatch(dashTypes.RECEIVED_HEADER_NOTI_TOTAL, 'P,Y,N,A')
                      swal({title: '', text: data.response, html: true, type: 'success'}, function () {
                        referenceButton.click()
                      })
                    })
                    .catch((error) => {
                      const data = error.response.data
                      swal({
                        title: '', text: data.response, html: true, type: 'error'
                      }, function () {
                        window.onkeydown = null; window.onfocus = null; swal('')
                      })
                    })
                  }
                })
              } else {
                dispatch(types.RECEIVED_HRES78U_INDEX, params.searchParams)
                dispatch(dashTypes.RECEIVED_HEADER_NOTI_TOTAL, 'P,Y,N,A')
                swal({title: '', text: data.response, html: true, type: 'success'}, function () {
                  referenceButton.click()
                })
              }
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres78u/index.js